module.exports = __webpack_public_path__ + "static/media/french_placket.b44fa1fb.svg";